var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6550_25386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 23.34C18.2631 23.34 23.3402 18.2629 23.3402 12C23.3402 5.73713 18.2631 0.660034 12.0002 0.660034C5.73725 0.660034 0.660156 5.73713 0.660156 12C0.660156 18.2629 5.73725 23.34 12.0002 23.34Z",
    fill: "#A4A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0098 22.75C16.2698 22.75 20.1198 20.25 21.8798 16.38C21.9498 16.22 21.8798 16.03 21.7198 15.95C21.6398 15.91 21.5398 15.91 21.4498 15.95C20.1298 16.55 18.7098 16.85 17.2598 16.85C11.6398 16.85 7.07977 12.29 7.07977 6.67002C7.07977 5.22002 7.38977 3.80002 7.97977 2.48002C8.04977 2.32002 7.97977 2.13002 7.81977 2.05002C7.73977 2.01002 7.63977 2.01002 7.54977 2.05002C2.09977 4.51002 -0.32023 10.92 2.13977 16.37C3.88977 20.25 7.74977 22.75 12.0098 22.74V22.75Z",
    fill: "#6E6E6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6550_25386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.4d25d00e4b308a824cb26fe51e10107f.svg";
export { ForwardRef as ReactComponent };